import {
    ControlcenterMelcoModelsMachineLicenseListItem,
    LicensesApi,
    useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
//import { ALL_ORDER_SESSION_STATUS, OrderProductionStatus, OrderSessionStatus } from "../../helper/machineLicensesHelper";
//import { MachineLicensesListFiltersType } from "./MachineLicensesListFiltersType";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { MachineLicensesListFiltersType } from "./MachineLicensesListFiltersType";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useMachineLicenses = () => {
    const {
        onTableConfigChange,
        pagination,
        setTotal,
        filters,
        filtersChange,
        sorter,
        currentPage,
        pageSize,
        sortBy,
    } = useTable<
        ControlcenterMelcoModelsMachineLicenseListItem,
        MachineLicensesListFiltersType
    >({
        pageSizeOptions: [10, 20],
        pageSize: 20,
    });

    //const baseApiConfig = useBaseAPIConfig();

    const query = useAPIQuery(
        LicensesApi,
        ["machineLicenses", currentPage, pageSize, filters, sortBy()],
        async (api) => {
            //const api = new SystemManagementApi(baseApiConfig({ token }));
            //console.log({filters, currentPage, pageSize})
            let response;

            //   if(filters?.Products) {
            response = await api.licensesMachineSearch({
                offset: (currentPage - 1) * pageSize,
                limit: pageSize,
                sortBy: sortBy(),
                userName: filters?.userName && !isEmpty(filters.userName)
                    ? filters?.userName
                    : "",
                searchText:
                    filters?.searchText && !isEmpty(filters.searchText)
                        ? filters?.searchText
                        : "",
                transactionId: filters?.transactionId && !isEmpty(filters.transactionId)
                    ? filters?.transactionId : "",
                licenseKey: filters?.licenseKey && !isEmpty(filters.licenseKey) ?
                    filters?.licenseKey : "",
                subType: filters?.subType && !isEmpty(filters?.subType) ?
                    filters?.subType?.join(",") : "",
                status: filters?.status && !isEmpty(filters.status)
                    ? filters.status.join(",") : "",
                expiresStartDate: filters?.expiresOnStartTimeStamp
                    ? filters.expiresOnStartTimeStamp : undefined,
                expiresEndDate: filters?.expiresOnEndTimeStamp
                    ? filters.expiresOnEndTimeStamp : undefined,
                renewsStartDate: filters?.renewsOnStartTimeStamp
                    ? filters.renewsOnStartTimeStamp : undefined,
                renewsEndDate: filters?.renewsOnEndTimeStamp
                    ? filters.renewsOnEndTimeStamp : undefined

            });
            //}

            setTotal(response?.total ? response?.total : 0);

            return response?.list ? response?.list : [];
        }
    );

    const errorComponent = useTableErrorComponent(query.error, query.refetch);

    return {
        onTableConfigChange,
        pagination,
        setTotal,
        filters,
        filtersChange,
        sorter,
        errorComponent,
        ...query,
    };
};
